import React from "react";

const Footbar = () => {
  return (
    <div>
      <footer className="text-center shadow-inner py-5">
        <span className="text-emerald-800 font-semibold">
          Blog App &copy; 2024
        </span>
      </footer>
    </div>
  );
};

export default Footbar;
